import { ModalCloseResult } from './modal-close-result';

export interface Modal<R = unknown> {
  result: Promise<ModalCloseResult<R>>;
  close(result?: ModalCloseResult<R>): void;
  dismiss(result?: ModalCloseResult<any>): void;
}
